import styled, { css } from 'styled-components';
import { colors } from '../../../stylesheets';

const StyledCard = styled.div`
  ${(props) =>
    props.width
      ? css`
          width: ${props.width};
        `
      : null};
  ${(props) =>
    props.height
      ? css`
          height: ${props.height};
        `
      : null};
  ${(props) =>
    props.hasShadow
      ? css`
          box-shadow: ${(props) =>
            props.sliderShadow ? colors.sliderBoxShadow : colors.boxShadow};
        `
      : null};
  border-radius: ${(props) => (props.hasRadius ? props.radius : 0)};
  ${(props) =>
    props.hasAnimation
      ? css`
          transition: all 0.5s;
        `
      : null};
  background-color: ${(props) => colors[props.type]};
  ${(props) =>
    props.hasBorder
      ? css`
          border: 1px solid ${colors[props.borderColor]};
        `
      : null};

  &:hover {
    ${(props) =>
      props.hasShadow
        ? css`
            box-shadow: ${(props) =>
              props.sliderShadow
                ? colors.sliderBoxShadowHover
                : colors.boxShadowHover};
          `
        : null};
  }
`;

export default StyledCard;
